export default import.meta.ROLLUP_FILE_URL_WbrYtjWYW7zJM88BoC7zDA